"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import {
  isHindiMobileJourney,
  mobileNavKeyForPath,
  type MobileNavKey,
} from "./mobile-bottom-bar-path";

const NAV_ID = "mobile-bottom-navigation";

function syncNavigation(pathname: string): void {
  const navigation = document.getElementById(NAV_ID);
  if (!(navigation instanceof HTMLElement)) return;

  const language = isHindiMobileJourney(pathname) ? "hi" : "en";
  const activeKey = mobileNavKeyForPath(pathname);
  navigation.lang = language;
  navigation.setAttribute(
    "aria-label",
    language === "hi" ? "Mukhya mobile navigation" : "Primary mobile navigation"
  );

  navigation.querySelectorAll<HTMLAnchorElement>("a[data-mobile-nav-key]").forEach((link) => {
    const key = link.dataset.mobileNavKey as MobileNavKey | undefined;
    const href = language === "hi" ? link.dataset.hiHref : link.dataset.enHref;
    if (href) link.setAttribute("href", href);

    const active = key === activeKey;
    link.toggleAttribute("aria-current", active);
    if (active) link.setAttribute("aria-current", "page");
    link.style.color = active ? "var(--ish-accent)" : "var(--ish-text-muted)";
    const label = link.querySelector("[data-mobile-nav-label]");
    label?.classList.toggle("font-semibold", active);
    label?.classList.toggle("font-medium", !active);
  });

  const remediesLabel = navigation.querySelector("[data-remedies-label]");
  if (remediesLabel) remediesLabel.textContent = language === "hi" ? "Upay" : "Remedies";
}

export default function MobileBottomBarState() {
  const pathname = usePathname() || "/";
  useEffect(() => syncNavigation(pathname), [pathname]);
  return null;
}
